import $ from "jquery";
/**
 * use toggleItem in another script via
 *      import * as menu from './toggle.js';
 *      menu.toggleItem();
 * or
 *      import {toggleItem} from './toggle.js';
 *      toggleItem();
 * @param e, slide
 */

const toggle = ( e, slide ) => {
    let button = e,
        buttonState = button.attr( 'aria-pressed' ),
        target = $('#' + e.attr('aria-controls'));

    	// Set fixed body if menu button is clicked
        if ( button.hasClass('menu-toggle') ) {
        	if (buttonState === 'false') {
        		$('body').addClass("fixed");
        	} else {
        		$('body').removeClass("fixed");
        	}
        }

        if (buttonState === 'false') {

            button.attr('aria-pressed', 'true');
            target.attr('aria-expanded', 'true');

            if ( slide === 'true' ) {
            	target.slideDown();
            }

        } else {

            button.attr('aria-pressed', 'false');
            target.attr('aria-expanded', 'false');

            if ( slide === 'true' ) {
            	target.slideUp();
            }
        }
};

export const toggleItem = (e = 'data-toggle') => {
    $('[' + e + ']').on('click', function(event){
        event.preventDefault();
        // If data-toggle="slide", pass true. If not, pass false.
        let useToggle = ($(this).attr(e) === 'slide') ? 'true' : 'false';
        toggle( $(this), useToggle );
    });
};


// WEBPACK FOOTER //
// ./resources/js/toggle.js